import { findLast, get, isEmpty, isNil } from "lodash";

export const formatFrozenValue = (value) => {
  if (value === undefined || value === null) return "";
  if (typeof value === "string") return value;
  if (typeof value === "number" || typeof value === "boolean") {
    return String(value);
  }
  return JSON.stringify(value);
};

export const parseFrozenValue = (raw) => {
  if (raw === undefined || raw === null) return undefined;
  const trimmed = String(raw).trim();
  if (trimmed === "") return undefined;
  if (trimmed === "true") return true;
  if (trimmed === "false") return false;
  if (/^-?\d+$/.test(trimmed) || /^-?\d+\.\d+$/.test(trimmed)) {
    const asNumber = Number(trimmed);
    if (Number.isFinite(asNumber) && String(asNumber) === trimmed) {
      return asNumber;
    }
  }
  if (/^[[{]/.test(trimmed)) {
    try {
      return JSON.parse(trimmed);
    } catch (_) {
      return trimmed;
    }
  }
  return trimmed;
};

export const mergeMappingRow = (row, patch) => {
  const next = { ...row, ...patch };
  if (
    Object.prototype.hasOwnProperty.call(patch, "value") &&
    (patch.value === undefined || patch.value === "")
  ) {
    delete next.value;
  }
  return next;
};

const namesOf = (mapping) => [mapping.name, ...(mapping.aliases || [])];

const matchesMapping = (mapping) => (row) =>
  namesOf(mapping).includes(get(row, "name"));

export const declaredMappings = (connector, config) => {
  const operations = get(connector, "operations") || [];
  if (!operations.length)
    return {
      operations,
      inputs: get(connector, "inputs") || [],
      outputs: get(connector, "outputs") || [],
    };
  const operation = operations.find(
    ({ key }) => key === get(config, "operation"),
  );
  return {
    operations,
    operation,
    inputs: get(operation, "inputs") || [],
    outputs: get(operation, "outputs") || [],
  };
};

const isEmptyMapping = (row) =>
  isEmpty(row.from) && isEmpty(row.to) && isNil(row.value);

const activeRow = (rows, mapping) => {
  for (const name of namesOf(mapping)) {
    const row = findLast(rows, (item) => get(item, "name") === name);
    if (!isNil(row)) return row;
  }
  return null;
};

export const mappingRow = (rows, mapping) =>
  activeRow(rows || [], mapping) || {};

export const setMappingRow = (rows, mapping, patch) => {
  const list = rows || [];
  const matches = matchesMapping(mapping);
  const first = list.findIndex(matches);
  const others = list.filter((row) => !matches(row));
  const next = mergeMappingRow(
    activeRow(list, mapping) || { name: mapping.name },
    patch,
  );
  if (isEmptyMapping(next)) return others;
  if (first === -1) return [...others, next];
  return [...others.slice(0, first), next, ...others.slice(first)];
};

export const unusedMappings = (rows, declared) => {
  const names = declared.flatMap(namesOf);
  return (rows || []).filter((row) => !names.includes(get(row, "name")));
};
